"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAvailable = void 0;
function isAvailable() {
    return typeof window !== 'undefined' && typeof window['IntersectionObserver'] !== 'undefined';
}
exports.isAvailable = isAvailable;
//# sourceMappingURL=intersection-pixel.js.map